module.exports = __webpack_public_path__ + "assets/img/thumb-D3-Security-Landing-Page-+-Website.647dce05.webp";